import {
    resizeFuncCheck,
    resizeFunc,
    resizecheck
} from './_resizecheck';

var gNavBtn, globalNav, scrollpos, overlay;
globalNav = '#globalNav';
gNavBtn   = '#gNavBtn';
overlay   = '.overlay';
export function headerFunc() {
    $(gNavBtn).on('click', function () {
        $(globalNav).toggleClass('active');
        $(overlay).fadeIn(500);
        $(this).toggleClass('active');

        if ($(this).hasClass('active')) {
            $(globalNav).find('ul').stop().slideDown({
                start: function () {
                    $(this).css({
                        display: "flex"
                    })
                }
            });
            scrollpos = $(window).scrollTop();
            $('body').addClass('fixedBody').css({
                'top': -scrollpos
            });
        } else {
            $('body').removeClass('fixedBody').css({
                'top': 0
            });
            window.scrollTo(0, scrollpos);
            $(globalNav).find('ul').stop().slideUp(500);
            $(overlay).fadeOut(500);
        }
    });

    $(overlay).on('click', function () {
        $(overlay).fadeOut(500);
        $(globalNav).removeClass('active');
        $(gNavBtn).removeClass('active');
        $(globalNav).find('ul').stop().slideUp(500);
        $('body').removeClass('fixedBody').css({
            'top': 0
        });
        window.scrollTo(0, scrollpos);
    });
}

//スマホ時にscrollした際にメニューを出したり出さなかったり
var startPos, TotalH, onFlag, footerH, nowPos, winScrollTop2, mainContentH, wH, result, footerSet, headerH2;
startPos = 0
winScrollTop2 = 0;
export function navigationLodeFunc() {
    resizeFuncCheck();
    resizeFunc();
    winScrollTop2 = $(window).scrollTop();
    wH = $(window).height();
    footerSet = $('#footer').offset().top;
    result = footerSet - wH;
    headerH2 = $('#header').outerHeight(true);
    if (resizecheck != 1) {
        if (winScrollTop2 > result || headerH2 > winScrollTop2 || winScrollTop2 == 0 || startPos == 0 || winScrollTop2 == startPos) {
            $(globalNav).removeClass('hide');
        } else if (winScrollTop2 >= startPos) {
            $(globalNav).addClass('hide');
        } else if (startPos > winScrollTop2) {
            $(globalNav).removeClass('hide');
        } else {
            $(globalNav).addClass('hide');
        }
        startPos = winScrollTop2;
    } else {
        //PC表示は消す
        $(globalNav).removeClass('hide');
    }
}

export var responsibleFlag, NUM;
export function test() {
    resizecheck = $('#responsibleCheck').width();
    if (resizecheck != 1) {
        responsibleFlag = 'PCだよ';
        NUM = 1;
    } else {
        responsibleFlag = 'SPだよ';
    }
    $(window).on('load', function () {
        //console.log('ロード');
    });
    $(window).on('scroll', function () {
        //console.log('スクロール');
    });
    $(window).on('resize', function () {
        //console.log('リサイズ');
    });
}

var headerH, headerH2, resizecheck, winScrollTop;
export function headerTrackingFunc() {
    $(window).on('load', function () {
        resizecheck = $('#responsibleCheck').width();
        headerH = $('#globalNav').offset().top;
        headerH2 = $('#globalNav').outerHeight(true);
        winScrollTop = $(this).scrollTop();
        if (resizecheck == 1) {
            if (winScrollTop >= headerH) {
                $('#globalNav').addClass('tracking');
                $('#mainContent').css('padding-top', headerH2);
            }
        }
        if (winScrollTop >= headerH) {
            $('#globalNav').addClass('tracking');
            $('#mainContent').css('padding-top', headerH2);
        }
        if (resizecheck != 1) {
            $('#globalNav').removeClass('tracking');
            $('#mainContent').removeAttr('style');
        }
        $(window).on('resize', function () {
            resizecheck = $('#responsibleCheck').width();
            if (resizecheck != 1) {
                $('#globalNav').removeClass('tracking');
                $('#mainContent').removeAttr('style');
            } else {
                $('#globalNav').find('ul').removeAttr('style');
                winScrollTop = $(this).scrollTop();
                headerH2 = $('#globalNav').outerHeight(true);
                if (winScrollTop >= headerH) {
                    $('#globalNav').addClass('tracking');
                    $('#mainContent').css('padding-top', headerH2);
                } else {
                    $('#globalNav').removeClass('tracking');
                    $('#mainContent').css('padding-top', '0');
                }
            }
        });
        $(window).on('scroll', function () {
            if (resizecheck == 1) {
                winScrollTop = $(this).scrollTop();
                headerH2 = $('#globalNav').outerHeight(true);
                if (winScrollTop >= headerH) {
                    $('#globalNav').addClass('tracking');
                    $('#mainContent').css('padding-top', headerH2);
                } else {
                    $('#globalNav').removeClass('tracking');
                    $('#mainContent').css('padding-top', '0');
                }
            }
        });
    });
}


//////////////////
// WEBPACK FOOTER
// ./src/js/common/_header.js
// module id = 4
// module chunks = 0